import { Modal, Text, Primary, Secondary } from '@cinch-labs/design-system'
import styles from './servicing-sign-in.module.css'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'

export interface ServicingSignInModalProps {
  onClose: () => void
}

export const ServicingSignInModal = ({
  onClose,
}: ServicingSignInModalProps) => {
  const { trackEvent } = useAnalytics()

  const handleClick = (buttonType: string) => {
    trackEvent({
      eventName: `${buttonType} button click`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'car_maintenance',
          action: `${buttonType}_button_click`,
        },
      },
    })

    window.location.assign(`/${buttonType}?channel=servicing`)
  }
  return (
    <Modal
      heading={'Sign up to book your service'}
      ariaLabelledById="book-service-sign-up"
      onClose={onClose}
    >
      <div className={styles.container}>
        <Text fontSizeFixed="s" className={styles.text}>
          Book your service from your cinch account.
        </Text>
        <hr className={styles.line} />
        <div className={styles.buttonContainer}>
          <Primary
            onClick={() => {
              handleClick('sign-up')
            }}
            isFullWidth
            classNames={{ button: styles.button }}
          >
            Sign up
          </Primary>
          <Secondary
            onClick={() => {
              handleClick('login')
            }}
            isFullWidth
            classNames={{ button: styles.button }}
          >
            Log in
          </Secondary>
        </div>
      </div>
    </Modal>
  )
}
